import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Slider,
  Typography,
} from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import { LANGUAGES } from '@constants/language';

import { SettingsGeneralViewProps } from './interfaces';
import { useStyles } from './styles';
import { env } from 'env';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { colors } from '@constants/colors';

const { REACT_APP_FEATURE_SHOW_LANGUAGE = 'true' } = env;

const showLanguage = REACT_APP_FEATURE_SHOW_LANGUAGE === 'true';

const SettingsGeneralView = ({
  selectLanguage,
  selectedLanguage,
  streamQuality,
  setStreamQuality,
  translate,
  gameSound,
  handleChange,
  participantsSound,
  handleLoudness,
  devices,
  externalKeyboardConnected,
  setExternalKeyboardConnected,
}: SettingsGeneralViewProps) => {
  const classes = useStyles();

  const languages = LANGUAGES.map(({ label, key }) => ({
    label,
    deviceId: key,
  }));

  return (
    <>
      {showLanguage ? (
        <HomeBottomButtonOptionsSettings
          devices={languages}
          handleSelect={(e) => selectLanguage(e.target.value)}
          label={translate('settingsModal.language')}
          selectedValue={selectedLanguage}
          sx={classes.buttonOptions}
        />
      ) : null}

      {/*<HomeBottomButtonOptionsSettings*/}
      {/*  devices={devices}*/}
      {/*  handleSelect={(e) => setStreamQuality(e.target.value)}*/}
      {/*  label={translate('settingsModal.quality')}*/}
      {/*  selectedValue={streamQuality}*/}
      {/*  SelectIcon={HighQualityIcon}*/}
      {/*/>*/}
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.worldSound')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={gameSound * 100}
          onChange={handleChange}
        />
      </Box>
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.loudness')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={participantsSound * 100}
          onChange={handleLoudness}
        />
      </Box>
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={externalKeyboardConnected}
              onChange={(e) => {
                setExternalKeyboardConnected(e.target.checked);
                localStorage.setItem('externalKeyboardConnected', e.target.checked.toString());
              }}
            />
          }
          label={translate('settingsModal.externalKeyboard')}
          sx={classes.label}
        />
      </Box>
    </>
  );
};

export default SettingsGeneralView;
